<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title>
        <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-food-fork-drink</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.iberostarFood') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5>
      </v-toolbar-title>
      <!--v-divider vertical  style="margin: 0 10px 0 10px;"/-->
    </v-toolbar>
    <div
      v-show="!collapseContent"
      style="padding: 0 10px 10px 10px;"
    >
      <v-select
        :items="restaurants"
        :label="$t('iberostarFood.restaurant')"
        item-text="Name"
        item-value="ID"
        v-model="content.IberostarFoodRestaurant"
        @change="handleChangeIsModified"
      />
      
      <!--v-text-field
        v-model="content.IberostarFoodRestaurant"
        append-icon="mdi-search"
        :label="$t('iberostarFood.restaurant')"
        hideDetails
        @input="handleChangeIsModified"
      /-->
      <v-layout wrap>
        <v-flex xs6>
          <v-layout wrap>
            <v-flex xs12>
                <div
                  class="text-center pt-2"
                >
                  {{ $t('iberostarFood.primaryColor') }}
                </div>
              </v-flex>
              <v-flex xs12>
                <center>
          <custom-color-picker-background-and-text
            style="width: 200px;margin: 20px 0;"
            :BGColor="content.IberostarFoodPrimaryBGColor"
            :TextColor="content.IberostarFoodPrimaryTextColor"
            :onChangeColor="handleChangePrimaryColor"
          />
                </center>
              </v-flex> 
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-layout wrap>
            <v-flex xs12>
                <div
                  class="text-center pt-2"
                >
                  {{ $t('settings.colors.textFormat') }}
                </div>
              </v-flex>
              <v-flex xs12>
                <div
                  class="text-center pt-2"
                >
                  <v-btn-toggle v-model="content.IberostarFoodPrimaryTextFormat" @change="handleChangeIsModified">
                    <v-btn :value="1">
                      <v-icon>mdi-format-letter-case-upper</v-icon>
                    </v-btn>

                    <v-btn :value="2">
                      <v-icon>mdi-format-letter-case-lower</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-flex> 
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs6>
          <v-layout wrap>
            <v-flex xs12>
                <div
                  class="text-center pt-2"
                >
                  {{ $t('iberostarFood.secondaryColor') }}
                </div>
              </v-flex>
              <v-flex xs12>
                <center>
          <custom-color-picker-background-and-text
            style="width: 200px;margin: 20px 0;"
            :BGColor="content.IberostarFoodSecondaryBGColor"
            :TextColor="content.IberostarFoodSecondaryTextColor"
            :onChangeColor="handleChangeSecondaryColor"
          />
                </center>
              </v-flex> 
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-layout wrap>
            <v-flex xs12>
                <div
                  class="text-center pt-2"
                >
                  {{ $t('settings.colors.textFormat') }}
                </div>
              </v-flex>
              <v-flex xs12>
                <div
                  class="text-center pt-2"
                >
                  <v-btn-toggle v-model="content.IberostarFoodSecondaryTextFormat" @change="handleChangeIsModified">
                    <v-btn :value="1">
                      <v-icon>mdi-format-letter-case-upper</v-icon>
                    </v-btn>

                    <v-btn :value="2">
                      <v-icon>mdi-format-letter-case-lower</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-flex> 
          </v-layout>
        </v-flex>
      </v-layout>
         
        <!--custom-color-picker-background-and-text
          style="width: 200px;margin: 20px 0;"
          :BGColor="content.IberostarFoodPrimaryBGColor"
          :TextColor="content.IberostarFoodPrimaryTextColor"
          :onChangeColor="handleChangePrimaryColor"
          :label="$t('iberostarFood.primaryColor')"
        />
        <custom-color-picker-background-and-text
          style="width: 200px;"
          :BGColor="content.IberostarFoodSecondaryBGColor"
          :TextColor="content.IberostarFoodSecondaryTextColor"
          :onChangeColor="handleChangeSecondaryColor"
          :label="$t('iberostarFood.secondaryColor')"
        /-->
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import api from '@/services/api'
  import Translate from '@/components/Translate'
  import CustomColorPickerBackgroundAndText from '@/components/CustomColorPickerBGAndText'
  export default {
    components: {
      Translate,
      CustomColorPickerBackgroundAndText
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      restaurants: null,
    }),
    computed: {
      ...mapState('app',['collapseContent', 'enterpriseID']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted () {
      this.getRestaurants()
    },
    methods: {
      getRestaurants() {
        api.getAll(`enterprises/iberostar/restaurants/${this.enterpriseID}`, true).then(response => {
          this.restaurants = response
        })
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      },
      handleChangePrimaryColor(bg, text) {
        this.content.IberostarFoodPrimaryBGColor = bg
        this.content.IberostarFoodPrimaryTextColor = text
        this.handleChangeIsModified()
      },
      handleChangeSecondaryColor(bg, text) {
        this.content.IberostarFoodSecondaryBGColor = bg
        this.content.IberostarFoodSecondaryTextColor = text
        this.handleChangeIsModified()
      },
    }
  }
</script>

<style scoped>
</style>

